import { Text } from '~/commonComponents';
import { useMediaQuery } from '~/hooks';
import { Colors } from '~/themes/colors';

export const TableHeader = () => {
  const [isSmallScreen] = useMediaQuery(['lg']);

  return (
    <thead style={{ borderBottom: '24px solid transparent' }}>
      <tr>
        <th style={{ width: 76 }} />
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Professional
          </Text>
        </th>
        {!isSmallScreen && (
          <th style={{ textAlign: 'left' }}>
            <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
              Office
            </Text>
          </th>
        )}
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Shift Details
          </Text>
        </th>
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Review
          </Text>
        </th>
        <th />
      </tr>
    </thead>
  );
};
